// Frequency units data for conversion routes
// Base unit: hertz (Hz)

export const frequencyUnits = [
  { id: 'hertz', name: 'Hertz', symbol: 'Hz', plural: 'Hertz', factor: 1 },
  { id: 'kilohertz', name: 'Kilohertz', symbol: 'kHz', plural: 'Kilohertz', factor: 1000 },
  { id: 'megahertz', name: 'Megahertz', symbol: 'MHz', plural: 'Megahertz', factor: 1000000 },
  { id: 'gigahertz', name: 'Gigahertz', symbol: 'GHz', plural: 'Gigahertz', factor: 1000000000 },
  { id: 'terahertz', name: 'Terahertz', symbol: 'THz', plural: 'Terahertz', factor: 1000000000000 },
  { id: 'millihertz', name: 'Millihertz', symbol: 'mHz', plural: 'Millihertz', factor: 0.001 },
  { id: 'rpm', name: 'Revolutions per minute', symbol: 'rpm', plural: 'Revolutions per minute', factor: 1/60 },
  { id: 'rps', name: 'Revolutions per second', symbol: 'rps', plural: 'Revolutions per second', factor: 1 },
  { id: 'radians-per-second', name: 'Radians per second', symbol: 'rad/s', plural: 'Radians per second', factor: 0.159155 },
  { id: 'cycles-per-second', name: 'Cycles per second', symbol: 'cps', plural: 'Cycles per second', factor: 1 },
];

// Popular conversions matching common usage
export const popularFrequencyConversions = [
  { from: 'hertz', to: 'kilohertz' },
  { from: 'kilohertz', to: 'hertz' },
  { from: 'kilohertz', to: 'megahertz' },
  { from: 'megahertz', to: 'kilohertz' },
  { from: 'megahertz', to: 'gigahertz' },
  { from: 'gigahertz', to: 'megahertz' },
  { from: 'hertz', to: 'megahertz' },
  { from: 'megahertz', to: 'hertz' },
  { from: 'hertz', to: 'gigahertz' },
  { from: 'gigahertz', to: 'hertz' },
  { from: 'rpm', to: 'hertz' },
  { from: 'hertz', to: 'rpm' },
  { from: 'rpm', to: 'radians-per-second' },
  { from: 'radians-per-second', to: 'rpm' },
  { from: 'gigahertz', to: 'terahertz' },
  { from: 'terahertz', to: 'gigahertz' },
];

export const getUnitById = (id) => frequencyUnits.find(unit => unit.id === id);

export const convertFrequency = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const hertz = value * fromUnit.factor;
  return hertz / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => `Convert ${fromUnit.plural} to ${toUnit.plural}`;

export const generateSEODescription = (fromUnit, toUnit) => {
  const result = convertFrequency(1, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000 ? result.toExponential(4) : result.toPrecision(6).replace(/\.?0+$/, '');
  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online frequency unit converter.`;
};
